export default {
  title: 'Site Search',
  placeholder: 'Please enter search keywords...',
  loading: 'Searching...',
  noResults: 'No related content found',
  button: 'Search'
}; 